/**
 * 渠道价格数据转换工具
 * 将后端返回的房型-渠道价格数据转换为图表所需格式
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * 移除房型名称中的括号及其内容
 * 例如："北京南锣鼓巷四合院店(府学)" -> "北京南锣鼓巷四合院店"
 * 例如："北京南锣鼓巷四合院店（府学）" -> "北京南锣鼓巷四合院店"
 */
export function removeParenthesesFromRoomTypeName(name) {
    if (!name)
        return name;
    // 移除所有括号及其内容，包括中文括号和英文括号
    // 使用全局替换，处理多个括号的情况
    return name.replace(/[（(][^）)]*[）)]/g, '').trim();
}
/** 判断是否为 PriceChannelResponse（组件用：顶层有 code、data.roomTypeList） */
function isPriceChannelResponseShape(v) {
    if (v == null || typeof v !== 'object')
        return false;
    var o = v;
    if (o.code !== 1 || o.data == null || typeof o.data !== 'object')
        return false;
    var d = o.data;
    return Array.isArray(d.roomTypeList);
}
/**
 * 将可能带「存储壳」的数据规范为组件使用的 PriceChannelResponse
 * 支持：直接 PriceChannelResponse，或 { data: PriceChannelResponse, fetchedAt? }
 */
export function normalizeToPriceChannelResponseForComponent(raw) {
    if (raw == null)
        return null;
    if (isPriceChannelResponseShape(raw))
        return raw;
    if (typeof raw === 'object' && raw !== null && 'data' in raw) {
        var inner = raw.data;
        if (isPriceChannelResponseShape(inner))
            return inner;
    }
    return null;
}
/**
 * 将 PMS getRoomPriceByChannel 原始响应（data 为数组或 { roomTypeList }）规范化为 PriceChannelResponse
 */
export function normalizeChannelPriceApiToResponse(raw, hotelId) {
    var _a, _b;
    if ((raw === null || raw === void 0 ? void 0 : raw.code) !== 1 || raw.data == null)
        return null;
    var data = raw.data;
    var hid = typeof hotelId === 'number' ? hotelId : parseInt(String(hotelId), 10) || 0;
    var dataObj = typeof data === 'object' && data !== null ? data : null;
    if (dataObj && !Array.isArray(data) && 'roomTypeList' in dataObj && Array.isArray(dataObj.roomTypeList)) {
        return {
            code: 1,
            data: {
                hotelId: (_a = dataObj.hotelId) !== null && _a !== void 0 ? _a : hid,
                hotelName: (_b = dataObj.hotelName) !== null && _b !== void 0 ? _b : "\u9152\u5E97 ".concat(hotelId),
                roomTypeList: dataObj.roomTypeList,
            },
        };
    }
    if (!Array.isArray(data) || data.length === 0)
        return null;
    var roomTypeMap = new Map();
    data.forEach(function (item) {
        var _a;
        var name = (_a = item.roomTypeName) !== null && _a !== void 0 ? _a : '未知房型';
        if (!roomTypeMap.has(name))
            roomTypeMap.set(name, []);
        roomTypeMap.get(name).push(item);
    });
    var roomTypeList = [];
    roomTypeMap.forEach(function (items, roomTypeName) {
        var _a, _b, _c, _d, _e, _f;
        var cleaned = removeParenthesesFromRoomTypeName(roomTypeName);
        var channelPriceList = items.map(function (item) {
            var _a, _b;
            var channelName = (_a = item.channelName) !== null && _a !== void 0 ? _a : '未知渠道';
            var discount = (_b = item.discount) !== null && _b !== void 0 ? _b : '无折扣';
            var price;
            var minPrice;
            var maxPrice;
            if (item.price != null)
                price = Number(item.price);
            else {
                if (item.minPrice != null)
                    minPrice = Number(item.minPrice);
                if (item.maxPrice != null)
                    maxPrice = Number(item.maxPrice);
            }
            return __assign(__assign(__assign({ channelName: channelName, discount: discount }, (price !== undefined ? { price: price } : {})), (minPrice !== undefined ? { minPrice: minPrice } : {})), (maxPrice !== undefined ? { maxPrice: maxPrice } : {}));
        });
        var maxLimitRatio = (_b = (_a = items[0]) === null || _a === void 0 ? void 0 : _a.maxLimitRatio) !== null && _b !== void 0 ? _b : 1999;
        var minLimitRatio = (_d = (_c = items[0]) === null || _c === void 0 ? void 0 : _c.minLimitRatio) !== null && _d !== void 0 ? _d : 329;
        var priceDifference = channelPriceList.reduce(function (max, item) {
            var _a, _b, _c, _d;
            var itemMax = (_b = (_a = item.maxPrice) !== null && _a !== void 0 ? _a : item.price) !== null && _b !== void 0 ? _b : 0;
            var itemMin = (_d = (_c = item.minPrice) !== null && _c !== void 0 ? _c : item.price) !== null && _d !== void 0 ? _d : 0;
            return Math.max(max, itemMax - itemMin);
        }, 0);
        roomTypeList.push({
            roomTypeName: cleaned,
            maxLimitRatio: Number(maxLimitRatio),
            minLimitRatio: Number(minLimitRatio),
            priceDifference: priceDifference,
            date: (_f = (_e = items[0]) === null || _e === void 0 ? void 0 : _e.date) !== null && _f !== void 0 ? _f : '',
            isPriceInverted: 0,
            channelPriceList: channelPriceList,
        });
    });
    return {
        code: 1,
        data: { hotelId: hid, hotelName: "\u9152\u5E97 ".concat(hotelId), roomTypeList: roomTypeList },
    };
}
/**
 * 方案1：分组K线图 - 按房型分组，每个房型显示所有渠道的价格范围
 * 适合：需要同时对比多个房型的价格分布
 */
export var transformToGroupedKlineChart = function (data) {
    var roomTypeList = data.data.roomTypeList;
    // 获取所有渠道名称（去重）
    var allChannels = Array.from(new Set(roomTypeList.flatMap(function (roomType) {
        return roomType.channelPriceList.map(function (channel) { return channel.channelName; });
    })));
    // 先收集所有房型名称作为 categories，移除括号及其内容
    var categories = roomTypeList.map(function (roomType) { return removeParenthesesFromRoomTypeName(roomType.roomTypeName); });
    // 为每个房型生成K线数据
    var series = [];
    roomTypeList.forEach(function (roomType, roomIndex) {
        // 每个房型作为一个分组
        // 为每个渠道生成K线数据
        allChannels.forEach(function (channelName) {
            var channelData = roomType.channelPriceList.find(function (ch) { return ch.channelName === channelName; });
            if (!channelData) {
                // 如果该房型没有这个渠道，跳过
                return;
            }
            // 计算价格范围
            var minPrice;
            var maxPrice;
            if (channelData.price !== undefined) {
                // 固定价格，设置一个小的范围用于显示
                minPrice = channelData.price;
                maxPrice = channelData.price;
            }
            else if (channelData.minPrice !== undefined && channelData.maxPrice !== undefined) {
                minPrice = channelData.minPrice;
                maxPrice = channelData.maxPrice;
            }
            else {
                // 没有价格数据，跳过
                return;
            }
            // K线数据格式：[开盘, 收盘, 最低, 最高]
            // 为了显示价格范围，开盘=最低，收盘=最高
            var klineData = [minPrice, maxPrice, minPrice, maxPrice];
            // 创建系列名称：使用渠道名作为系列名（多个房型共享同一个渠道系列）
            var seriesName = channelName;
            // 查找或创建系列（按渠道名称查找，不是按房型-渠道组合）
            var seriesItem = series.find(function (s) { return s.name === seriesName; });
            if (!seriesItem) {
                seriesItem = {
                    id: seriesName,
                    name: channelName,
                    dataKey: seriesName,
                    type: "candlestick",
                    axisId: "left",
                    data: new Array(roomTypeList.length).fill(null),
                };
                series.push(seriesItem);
            }
            // 设置该房型位置的数据（确保数据格式正确）
            // 如果 minPrice === maxPrice（固定价格），设置一个小的范围以便显示
            if (minPrice === maxPrice && minPrice > 0) {
                var priceRange = minPrice * 0.01; // 1%的范围
                seriesItem.data[roomIndex] = [
                    minPrice - priceRange,
                    maxPrice + priceRange,
                    minPrice,
                    maxPrice, // 最高
                ];
            }
            else {
                seriesItem.data[roomIndex] = klineData;
            }
        });
    });
    // 计算Y轴范围
    var allPrices = roomTypeList.flatMap(function (roomType) {
        return roomType.channelPriceList.flatMap(function (channel) {
            if (channel.price !== undefined) {
                return [channel.price];
            }
            if (channel.minPrice !== undefined && channel.maxPrice !== undefined) {
                return [channel.minPrice, channel.maxPrice];
            }
            return [];
        });
    });
    // 如果没有价格数据，返回默认值
    if (allPrices.length === 0) {
        return {
            categories: [],
            dataset: {},
            axes: {
                left: {
                    id: "left",
                    position: "left",
                    name: "价格",
                    unit: "元",
                    min: 0,
                    max: 1000,
                },
            },
            series: [],
        };
    }
    var maxPrice = Math.max.apply(Math, allPrices);
    // 价格坐标轴按所有价格最高的130%显示最大刻度
    var yAxisMin = 0; // 最小值始终为0
    var yAxisMax = Math.ceil(maxPrice * 1.3); // 最大值为最高价的130%
    // 确保至少有一个系列数据
    if (series.length === 0 || categories.length === 0) {
        return {
            categories: [],
            dataset: {},
            axes: {
                left: {
                    id: "left",
                    position: "left",
                    name: "价格",
                    unit: "元",
                    min: yAxisMin,
                    max: yAxisMax,
                    axisLabel: {
                        formatter: function (value) {
                            // 格式化为整数，不显示小数
                            return Math.round(value).toString();
                        },
                    },
                },
            },
            series: [],
        };
    }
    // 构建 dataset，确保所有系列的数据数组长度与 categories 一致
    var dataset = series.reduce(function (acc, seriesItem) {
        // 确保数据数组长度与 categories 一致，缺失的数据用 null 填充
        var dataArray = new Array(categories.length).fill(null);
        seriesItem.data.forEach(function (value, index) {
            if (value !== null && value !== undefined) {
                dataArray[index] = value;
            }
        });
        acc[seriesItem.dataKey] = dataArray;
        return acc;
    }, {});
    return {
        categories: categories,
        dataset: dataset,
        axes: {
            left: {
                id: "left",
                position: "left",
                name: "价格",
                unit: "元",
                min: yAxisMin,
                max: yAxisMax,
                axisLabel: {
                    formatter: function (value) {
                        // 格式化为整数，不显示小数
                        return Math.round(value).toString();
                    },
                },
            },
        },
        series: series.map(function (s) { return ({
            id: s.id,
            name: s.name,
            dataKey: s.dataKey,
            type: s.type,
            axisId: s.axisId,
            // 分组K线图配置
            barWidth: "60%",
            barGap: "30%",
            barCategoryGap: "20%",
            itemStyle: {
                color: "#00da3c",
                color0: "#ec0000",
                borderWidth: 0, // 边框宽度
            },
        }); }),
    };
};
/**
 * 方案2：单房型多渠道K线图 - 选择一个房型，显示该房型所有渠道的价格范围
 * 适合：需要详细分析某个房型的价格分布
 */
export var transformToSingleRoomTypeKlineChart = function (data, selectedRoomType) {
    var roomTypeList = data.data.roomTypeList;
    // 选择房型：下拉展示的是去掉括号后的名称，这里用清理后的名称匹配，避免「和风榻榻米」选不中「和风榻榻米(xxx)」
    var roomType = selectedRoomType
        ? roomTypeList.find(function (rt) { return removeParenthesesFromRoomTypeName(rt.roomTypeName) === selectedRoomType; })
        : roomTypeList[0];
    if (!roomType) {
        return null;
    }
    // 提取渠道名称作为 categories（注意：这里不需要处理房型名称，因为 categories 是渠道名称）
    var categories = roomType.channelPriceList.map(function (ch) { return ch.channelName; });
    // 生成K线数据，确保与categories一一对应
    var klineData = roomType.channelPriceList.map(function (channel, index) {
        var _a;
        var minPrice;
        var maxPrice;
        if (channel.price !== undefined && channel.price !== null) {
            minPrice = Number(channel.price);
            maxPrice = Number(channel.price);
        }
        else if (channel.minPrice !== undefined && channel.minPrice !== null &&
            channel.maxPrice !== undefined && channel.maxPrice !== null) {
            minPrice = Number(channel.minPrice);
            maxPrice = Number(channel.maxPrice);
        }
        else {
            // 默认值
            minPrice = 0;
            maxPrice = 0;
        }
        // 确保所有值都是有效数字
        minPrice = isNaN(minPrice) ? 0 : minPrice;
        maxPrice = isNaN(maxPrice) ? 0 : maxPrice;
        // 确保 minPrice <= maxPrice
        if (minPrice > maxPrice) {
            _a = [maxPrice, minPrice], minPrice = _a[0], maxPrice = _a[1];
        }
        // K线数据格式：[开盘, 收盘, 最低, 最高]
        // 开盘=最低，收盘=最高，只显示价格范围，不显示开盘和收盘
        // 如果价格是固定值，设置一个小的范围以便显示
        var open;
        var close;
        var low;
        var high;
        if (minPrice === maxPrice && minPrice > 0) {
            var priceRange = minPrice * 0.01; // 1%的范围
            open = Math.max(0, minPrice - priceRange);
            close = maxPrice + priceRange;
            low = minPrice;
            high = maxPrice;
        }
        else {
            open = Math.max(0, minPrice);
            close = maxPrice;
            low = Math.max(0, minPrice);
            high = maxPrice;
        }
        // 返回K线数据，确保所有值都是有效数字且非负数
        // 使用 Number() 和 isFinite() 双重验证
        var finalOpen = Math.max(0, Number.isFinite(Number(open)) ? Number(open) : 0);
        var finalClose = Math.max(0, Number.isFinite(Number(close)) ? Number(close) : 0);
        var finalLow = Math.max(0, Number.isFinite(Number(low)) ? Number(low) : 0);
        var finalHigh = Math.max(0, Number.isFinite(Number(high)) ? Number(high) : 0);
        // 确保 low <= high 和 open <= close（K线图的基本要求）
        var finalLowest = Math.min(finalLow, finalHigh);
        var finalHighest = Math.max(finalLow, finalHigh);
        var finalOpenPrice = Math.min(finalOpen, finalClose);
        var finalClosePrice = Math.max(finalOpen, finalClose);
        // 最终验证：确保所有值都是有效数字
        var result = [
            Number.isFinite(finalOpenPrice) ? finalOpenPrice : 0,
            Number.isFinite(finalClosePrice) ? finalClosePrice : 0,
            Number.isFinite(finalLowest) ? finalLowest : 0,
            Number.isFinite(finalHighest) ? finalHighest : 0,
        ];
        // 如果所有值都是0，跳过这条数据（在后续过滤中处理）
        return result;
    });
    // 计算X轴范围（价格轴，因为横向显示）
    var allPrices = roomType.channelPriceList.flatMap(function (channel) {
        var prices = [];
        if (channel.price !== undefined && channel.price !== null) {
            var price = Number(channel.price);
            if (!isNaN(price)) {
                prices.push(price);
            }
        }
        if (channel.minPrice !== undefined && channel.minPrice !== null) {
            var minPrice = Number(channel.minPrice);
            if (!isNaN(minPrice)) {
                prices.push(minPrice);
            }
        }
        if (channel.maxPrice !== undefined && channel.maxPrice !== null) {
            var maxPrice_1 = Number(channel.maxPrice);
            if (!isNaN(maxPrice_1)) {
                prices.push(maxPrice_1);
            }
        }
        return prices;
    });
    if (allPrices.length === 0) {
        return {
            categories: [],
            dataset: {
                klineData: [],
            },
            axes: {
                left: {
                    id: "left",
                    position: "left",
                    name: "",
                    unit: "",
                    type: "category",
                    data: [],
                },
                bottom: {
                    id: "bottom",
                    position: "bottom",
                    name: "价格",
                    unit: "元",
                    min: 0,
                    max: 1000,
                    type: "value",
                    axisLabel: {
                        formatter: function (value) {
                            return Math.round(value).toString();
                        },
                    },
                },
            },
            series: [],
        };
    }
    // 确保所有价格都是有效数字
    var validPrices = allPrices.filter(function (p) { return typeof p === 'number' && !isNaN(p) && isFinite(p); });
    // 仅将 minLimitRatio 纳入范围计算，确保下限参考线可见；maxLimitRatio 值通常过大，忽略
    var minLimitRatio = roomType.minLimitRatio;
    if (typeof minLimitRatio === 'number' && Number.isFinite(minLimitRatio) && minLimitRatio > 0) {
        validPrices.push(minLimitRatio);
    }
    if (validPrices.length === 0) {
        // 如果没有有效价格，使用默认范围
        validPrices.push(0, 1000);
    }
    // 价格坐标轴按当前房型实际渠道价格及限价计算
    var maxPrice = Math.max.apply(Math, validPrices);
    // 价格坐标轴：最小值 0，最大值至少 800，若最高价超过 800 则按最高价的 130% 计算
    var priceAxisMin = 0;
    var priceAxisMax = Math.max(800, Math.ceil(maxPrice * 1.05));
    // 调试日志
    if (process.env.NODE_ENV === 'development') {
        console.log('[priceChannelDataTransformer] 坐标轴范围计算:', {
            maxPrice: maxPrice,
            priceAxisMin: priceAxisMin,
            priceAxisMax: priceAxisMax,
            roomTypeName: roomType.roomTypeName,
        });
    }
    // 确保 min 和 max 都是有效数字
    if (!Number.isFinite(priceAxisMin) || !Number.isFinite(priceAxisMax)) {
        // 如果计算失败，使用默认值
        var defaultMin = 0;
        var defaultMax = 1000;
        return {
            categories: [],
            dataset: {
                klineData: [],
            },
            axes: {
                left: {
                    id: "left",
                    position: "left",
                    name: "",
                    unit: "",
                    type: "category",
                    data: [],
                },
                bottom: {
                    id: "bottom",
                    position: "bottom",
                    name: "价格",
                    unit: "元",
                    min: defaultMin,
                    max: defaultMax,
                    type: "value",
                    axisLabel: {
                        formatter: function (value) { return Math.round(value).toString(); },
                    },
                },
                right: {
                    id: "right",
                    position: "right",
                    name: "价格",
                    unit: "元",
                    min: defaultMin,
                    max: defaultMax,
                    type: "value",
                    axisLabel: {
                        formatter: function (value) { return Math.round(value).toString(); },
                    },
                },
            },
            series: [],
        };
    }
    // 确保 categories 和 klineData 长度一致
    var validCategories = [];
    var validKlineData = [];
    categories.forEach(function (category, index) {
        var kline = klineData[index];
        if (kline && Array.isArray(kline) && kline.length === 4) {
            // 检查K线数据是否有效（所有值都是有效数字且至少有一个非零值）
            var allValid = kline.every(function (v) {
                var num = Number(v);
                return Number.isFinite(num) && !isNaN(num) && num >= 0;
            });
            // 至少有一个非零值，确保K线可见
            var hasNonZero = kline.some(function (v) { return Number(v) > 0; });
            if (allValid && hasNonZero) {
                // 再次确保所有值都是数字类型
                var validatedKline = kline.map(function (v) {
                    var num = Number(v);
                    return Number.isFinite(num) ? num : 0;
                });
                validCategories.push(String(category || ''));
                validKlineData.push(validatedKline);
            }
        }
    });
    // 如果没有有效数据，返回空结构
    if (validCategories.length === 0 || validKlineData.length === 0) {
        return {
            categories: [],
            dataset: {
                klineData: [],
            },
            axes: {
                left: {
                    id: "left",
                    position: "left",
                    name: "",
                    unit: "",
                    type: "category",
                    data: [],
                },
                bottom: {
                    id: "bottom",
                    position: "bottom",
                    name: "价格",
                    unit: "元",
                    min: 0,
                    max: 800,
                    type: "value",
                    axisLabel: {
                        formatter: function (value) { return Math.round(value).toString(); },
                    },
                },
                right: {
                    id: "right",
                    position: "right",
                    name: "价格",
                    unit: "元",
                    min: 0,
                    max: 800,
                    type: "value",
                    axisLabel: {
                        formatter: function (value) { return Math.round(value).toString(); },
                    },
                },
            },
            series: [],
        };
    }
    // 计算平均价格（如果有的话）
    var averagePrice = roomType.channelPriceList.map(function (channel) {
        if (channel.price !== undefined && channel.price !== null) {
            return Number(channel.price);
        }
        else if (channel.minPrice !== undefined && channel.maxPrice !== undefined) {
            return (Number(channel.minPrice) + Number(channel.maxPrice)) / 2;
        }
        return 0;
    }).filter(function (_, index) {
        // 只保留有效数据对应的平均价格
        return index < validCategories.length;
    });
    // 横向K线图：渠道名称作为Y轴（左侧），价格作为X轴（底部和右侧）
    var result = __assign({ categories: validCategories, dataset: {
            klineData: validKlineData,
            averagePrice: averagePrice.length > 0 ? averagePrice : undefined,
        }, axes: {
            left: {
                id: "left",
                position: "left",
                name: "",
                unit: "",
                type: "category",
                data: validCategories,
                axisLabel: {
                    interval: 0,
                    // 超长标签截断，添加省略号（3个字后截断）
                    formatter: function (value) {
                        var strValue = String(value);
                        // 如果超过3个字，截断并添加省略号
                        if (strValue.length > 3) {
                            return strValue.substring(0, 3) + '...';
                        }
                        return strValue;
                    },
                },
            },
            bottom: {
                id: "bottom",
                position: "bottom",
                name: "价格",
                unit: "元",
                min: Number.isFinite(priceAxisMin) ? priceAxisMin : 0,
                max: Number.isFinite(priceAxisMax) ? priceAxisMax : 1000,
                type: "value",
                axisLabel: {
                    formatter: function (value) {
                        // 格式化为整数，不显示小数
                        if (!Number.isFinite(value))
                            return "0";
                        return Math.round(value).toString();
                    },
                },
            },
            right: {
                id: "right",
                position: "right",
                name: "价格",
                unit: "元",
                min: Number.isFinite(priceAxisMin) ? priceAxisMin : 0,
                max: Number.isFinite(priceAxisMax) ? priceAxisMax : 1000,
                type: "value",
                axisLabel: {
                    formatter: function (value) {
                        // 格式化为整数，不显示小数
                        if (!Number.isFinite(value))
                            return "0";
                        return Math.round(value).toString();
                    },
                },
            },
        }, series: __spreadArray([
            {
                id: "kline",
                name: "价格范围",
                dataKey: "klineData",
                type: "candlestick",
                axisId: "left",
                barWidth: 16,
                // 不分组，不设置 barGap
                itemStyle: {
                    color: "#00da3c",
                    color0: "#ec0000",
                    borderWidth: 0, // 边框宽度
                },
            }
        ], (averagePrice.length > 0 && averagePrice.some(function (p) { return p > 0; }) ? [{
                id: "averagePrice",
                name: "平均价",
                dataKey: "averagePrice",
                type: "line",
                axisId: "right",
                smooth: false,
                symbol: "circle",
                symbolSize: 6,
                itemStyle: {
                    color: "#1890ff", // 蓝色
                },
                lineStyle: {
                    color: "#1890ff",
                    width: 2,
                },
            }] : []), true) }, (typeof minLimitRatio === 'number' && Number.isFinite(minLimitRatio) && minLimitRatio > 0
        ? {
            markLines: [
                {
                    value: minLimitRatio,
                    name: "下限价",
                    axisId: "right",
                    silent: true,
                    color: "#52c41a",
                    lineStyle: {
                        type: "dashed",
                        width: 2,
                    },
                    label: {
                        show: true,
                        formatter: function () { return "\u4E0B\u9650\u4EF7 ".concat(Math.round(minLimitRatio)); },
                    },
                },
            ],
        }
        : {}));
    return result;
};
/**
 * 方案3：热力图数据转换
 * 房型为行，渠道为列，颜色表示价格（使用平均价或最高价）
 */
export var transformToHeatmapChart = function (data) {
    var roomTypeList = data.data.roomTypeList;
    // 获取所有渠道名称（去重）
    var allChannels = Array.from(new Set(roomTypeList.flatMap(function (roomType) {
        return roomType.channelPriceList.map(function (channel) { return channel.channelName; });
    })));
    // 生成热力图数据
    var values = [];
    var yCategories = [];
    var xCategories = allChannels;
    roomTypeList.forEach(function (roomType) {
        yCategories.push(roomType.roomTypeName);
        var row = [];
        allChannels.forEach(function (channelName) {
            var channelData = roomType.channelPriceList.find(function (ch) { return ch.channelName === channelName; });
            if (!channelData) {
                row.push(0); // 没有数据
                return;
            }
            // 使用平均价作为热力图的值
            var value;
            if (channelData.price !== undefined) {
                value = channelData.price;
            }
            else if (channelData.minPrice !== undefined &&
                channelData.maxPrice !== undefined) {
                value = (channelData.minPrice + channelData.maxPrice) / 2;
            }
            else {
                value = 0;
            }
            row.push(value);
        });
        values.push(row);
    });
    return {
        xCategories: xCategories,
        yCategories: yCategories,
        values: values,
    };
};
/**
 * 方案4：分组误差棒柱状图
 * 每个房型一组，用柱状图显示平均价，误差棒显示价格范围
 */
export var transformToGroupedBarWithErrorChart = function (data) {
    var roomTypeList = data.data.roomTypeList;
    // 获取所有渠道名称（去重）
    var allChannels = Array.from(new Set(roomTypeList.flatMap(function (roomType) {
        return roomType.channelPriceList.map(function (channel) { return channel.channelName; });
    })));
    var categories = roomTypeList.map(function (rt) { return removeParenthesesFromRoomTypeName(rt.roomTypeName); });
    var series = [];
    // 为每个渠道创建一个系列
    allChannels.forEach(function (channelName) {
        var averagePrices = [];
        var minPrices = [];
        var maxPrices = [];
        roomTypeList.forEach(function (roomType) {
            var channelData = roomType.channelPriceList.find(function (ch) { return ch.channelName === channelName; });
            if (!channelData) {
                averagePrices.push(0);
                minPrices.push(0);
                maxPrices.push(0);
                return;
            }
            var avg;
            var min;
            var max;
            if (channelData.price !== undefined) {
                avg = channelData.price;
                min = channelData.price;
                max = channelData.price;
            }
            else if (channelData.minPrice !== undefined &&
                channelData.maxPrice !== undefined) {
                min = channelData.minPrice;
                max = channelData.maxPrice;
                avg = (min + max) / 2;
            }
            else {
                avg = 0;
                min = 0;
                max = 0;
            }
            averagePrices.push(avg);
            minPrices.push(min);
            maxPrices.push(max);
        });
        series.push({
            id: channelName,
            name: channelName,
            dataKey: "".concat(channelName, "_avg"),
            type: "bar",
            axisId: "left",
            data: averagePrices,
            // 误差棒数据（如果图表库支持）
            errorData: {
                min: minPrices,
                max: maxPrices,
            },
        });
    });
    // 计算Y轴范围
    var allPrices = roomTypeList.flatMap(function (roomType) {
        return roomType.channelPriceList.flatMap(function (channel) {
            if (channel.price !== undefined) {
                return [channel.price];
            }
            if (channel.minPrice !== undefined && channel.maxPrice !== undefined) {
                return [channel.minPrice, channel.maxPrice];
            }
            return [];
        });
    });
    var maxPrice = Math.max.apply(Math, allPrices);
    // 价格坐标轴按所有价格最高的130%显示最大刻度
    var yAxisMin = 0; // 最小值始终为0
    var yAxisMax = Math.ceil(maxPrice * 1.3); // 最大值为最高价的130%
    return {
        categories: categories,
        dataset: series.reduce(function (acc, seriesItem) {
            acc[seriesItem.dataKey] = seriesItem.data;
            return acc;
        }, {}),
        axes: {
            left: {
                id: "left",
                position: "left",
                name: "价格",
                unit: "元",
                min: yAxisMin,
                max: yAxisMax,
                axisLabel: {
                    formatter: function (value) {
                        return Number.isFinite(value) ? Math.round(value).toString() : "0";
                    },
                },
            },
        },
        series: series.map(function (s) { return ({
            id: s.id,
            name: s.name,
            dataKey: s.dataKey,
            type: s.type,
            axisId: s.axisId,
        }); }),
    };
};
/**
 * 方案4.5：将 PriceChannelResponse 数据转换为纵向折线图格式
 * 渠道在X轴，价格在Y轴
 * 适合：需要查看不同渠道的价格对比
 */
export var transformToChannelPriceLineChart = function (data, selectedRoomType) {
    var roomTypeList = data.data.roomTypeList;
    // 选择房型（默认第一个）
    var roomType = selectedRoomType
        ? roomTypeList.find(function (rt) { return rt.roomTypeName === selectedRoomType; })
        : roomTypeList[0];
    if (!roomType) {
        return null;
    }
    // 提取渠道名称作为 categories（X轴）
    var categories = roomType.channelPriceList.map(function (ch) { return ch.channelName; });
    // 提取价格数据（使用平均价或固定价）
    var priceData = roomType.channelPriceList.map(function (channel) {
        if (channel.price !== undefined && channel.price !== null) {
            return Number(channel.price);
        }
        else if (channel.minPrice !== undefined && channel.maxPrice !== undefined) {
            // 使用平均价
            return (Number(channel.minPrice) + Number(channel.maxPrice)) / 2;
        }
        return null;
    });
    // 过滤掉无效数据
    var validData = priceData.filter(function (p) { return p !== null && Number.isFinite(p); });
    if (validData.length === 0) {
        return null;
    }
    // 价格坐标轴只按当前房型实际渠道价格计算
    var maxPrice = Math.max.apply(Math, validData);
    // 价格坐标轴按当前房型最大价值的130%显示最大刻度
    var priceAxisMax = Math.ceil(maxPrice * 1.3); // 最大值为当前房型最高价的130%
    return {
        categories: categories,
        dataset: {
            channelPrice: priceData, // 渠道价格数据
        },
        axes: {
            left: {
                id: "left",
                position: "left",
                name: "价格",
                unit: "元",
                min: 0,
                max: Number.isFinite(priceAxisMax) ? priceAxisMax : 1000,
                type: "value",
                axisLabel: {
                    formatter: function (value) {
                        if (!Number.isFinite(value))
                            return "0";
                        return Math.round(value).toString();
                    },
                },
            },
            bottom: {
                id: "bottom",
                position: "bottom",
                name: "渠道",
                type: "category",
                data: categories,
                axisLabel: {
                    interval: 0,
                    formatter: function (value) {
                        var strValue = String(value);
                        // 如果超过3个字，截断并添加省略号
                        if (strValue.length > 3) {
                            return strValue.substring(0, 3) + '...';
                        }
                        return strValue;
                    },
                },
            },
        },
        series: [
            {
                id: "channelPrice",
                name: "渠道价格",
                dataKey: "channelPrice",
                type: "line",
                axisId: "left",
                smooth: false,
                symbol: "circle",
                symbolSize: 6,
                itemStyle: {
                    color: "#1890ff", // 蓝色折线
                },
                lineStyle: {
                    color: "#1890ff",
                    width: 2,
                },
            },
        ],
    };
};
/**
 * 方案5：将 getAliasPriceQuantity 接口数据转换为折线图格式
 * 每个房型（alias）的价格按时间（日期）绘制成折线图
 * 适合：需要查看渠道价格随时间的变化趋势
 */
export var transformAliasPriceQuantityToLineChart = function (data, selectedRoomType) {
    if (!data.data || data.data.length === 0) {
        return null;
    }
    // 提取日期作为 categories（X轴）
    var categories = data.data.map(function (day) {
        var date = new Date(day.date * 1000);
        return "".concat(date.getMonth() + 1, "/").concat(date.getDate());
    });
    // 提取所有房型名称（去重）
    var allRoomTypes = Array.from(new Set(data.data.flatMap(function (day) { return day.aliases.map(function (alias) { return alias.aliasName; }); })));
    // 如果指定了房型，只显示该房型；否则显示第一个房型
    var targetRoomType = selectedRoomType
        ? allRoomTypes.find(function (rt) { return rt === selectedRoomType; })
        : allRoomTypes[0];
    if (!targetRoomType) {
        return null;
    }
    // 为每个房型提取价格数据（按日期）
    var priceData = data.data.map(function (day) {
        var alias = day.aliases.find(function (a) { return a.aliasName === targetRoomType; });
        return alias ? alias.currentPrice : null;
    });
    // 过滤掉无效数据
    var validData = priceData.filter(function (p) { return p !== null && Number.isFinite(p); });
    if (validData.length === 0) {
        return null;
    }
    // 价格坐标轴只按当前房型实际价格数据计算
    var finalMaxPrice = Math.max.apply(Math, validData);
    // 价格坐标轴按当前房型最大价值的130%显示最大刻度
    var priceAxisMax = Math.ceil(finalMaxPrice * 1.3); // 最大值为当前房型最高价的130%
    return {
        categories: categories,
        dataset: {
            channelPrice: priceData, // 渠道价格数据
        },
        axes: {
            left: {
                id: "left",
                position: "left",
                name: "价格",
                unit: "元",
                min: 0,
                max: Number.isFinite(priceAxisMax) ? priceAxisMax : 1000,
                type: "value",
                axisLabel: {
                    formatter: function (value) {
                        if (!Number.isFinite(value))
                            return "0";
                        return Math.round(value).toString();
                    },
                },
            },
            bottom: {
                id: "bottom",
                position: "bottom",
                name: "日期",
                type: "category",
                data: categories,
                axisLabel: {
                    interval: 0, // 强制显示所有标签
                },
            },
        },
        series: [
            {
                id: "channelPrice",
                name: "渠道价格",
                dataKey: "channelPrice",
                type: "line",
                axisId: "left",
                smooth: false,
                symbol: "circle",
                symbolSize: 6,
                itemStyle: {
                    color: "#ff4d4f", // 红色折线
                },
                lineStyle: {
                    color: "#ff4d4f",
                    width: 2,
                },
            },
        ],
    };
};
